import { Component } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import Hint from '@components/Hint.tsx'
import TimetoastPropTypes from '@constants/timetoast_prop_types.js'
import TimelineGridContainer from '@features/timeline_grid/containers/timeline_grid_container.js'
import LinkButton from '@components/LinkButton.tsx'
import Pagination from '@components/Pagination.tsx'
import HorizontalSpinner from '@components/HorizontalSpinner.tsx'

export default class IndexTab extends Component {
  static propTypes = {
    group: TimetoastPropTypes.group.isRequired,
    pagination: TimetoastPropTypes.pagination,
    gridItems: PropTypes.array,
    currentPage: PropTypes.number.isRequired,
    onPaginate: PropTypes.func.isRequired,
    loadData: PropTypes.func.isRequired,
  }

  static defaultProps = {
    gridItems: [],
    currentPage: 1,
    onPaginate: noop,
    loadData: noop,
  }

  componentDidMount() {
    const { currentPage, loadData, group } = this.props
    loadData(currentPage, group.id)
  }

  handlePaginationPageClick = pageNumber => {
    const { group, onPaginate } = this.props
    onPaginate(pageNumber, group.id)
  }

  getGridContent() {
    const { pagination } = this.props
    if (!pagination || pagination.isFetching) {
      return (
        <div className="block">
          <HorizontalSpinner size="large" />
        </div>
      )
    } else {
      const gridItemIds = pagination.ids
      return <TimelineGridContainer gridItemIds={gridItemIds} />
    }
  }

  getPaginationContent() {
    const { pagination } = this.props
    if (pagination) {
      if (pagination.totalCount > pagination.perPage) {
        return <Pagination onPaginationPageClick={this.handlePaginationPageClick} {...pagination} />
      }
    }
    return null
  }

  getHeaderContent() {
    const { group } = this.props
    return (
      <header className="p">
        <h1>
          {group.name} timelines{' '}
          <Hint position="bottom" hint="Create a timeline and collaborate with this group for it to appear here." />
        </h1>
      </header>
    )
  }

  getGroupMembersLink() {
    const { group } = this.props
    if (group) {
      const href = `/groups/${group.id}`
      return (
        <LinkButton href={href} className="btn btn--outline view-group-members-button">
          View group members
        </LinkButton>
      )
    }
    return null
  }

  render() {
    const header = this.getHeaderContent()
    const pagination = this.getPaginationContent()
    const gridContent = this.getGridContent()
    const groupMembersLink = this.getGroupMembersLink()
    return (
      <>
        {header}
        {gridContent}
        <footer>
          {groupMembersLink}
          {pagination}
        </footer>
      </>
    )
  }
}
